const PROD_HOST = "webapp-tsa-api-dpbtdtegeth0hgct.westeurope-01.azurewebsites.net";
const TEST_HOST = "webapp-tsa-api-test.azurewebsites.net";

function resolveHost() {
    const hostname = window.location.hostname || "";
    if (hostname.includes("localhost")) {
        return "localhost";
    }
    if (hostname.includes("elearning-test.")) {
        return TEST_HOST;
    }
    return PROD_HOST;
}

export function baseUrl() {
    if (window.location.href.includes('localhost')) {
        return `https://localhost:7148/api/`;
    }
    else {
        return `https://${resolveHost()}/api/`
    }
}

export function playCourseUrl() {
    if (window.location.href.includes('localhost')) {
        return `https://localhost:7148/course/`;
    }
    else {
        return `https://${resolveHost()}/course/`
    }
}

export function rteUrl() {
    if (window.location.href.includes('localhost')) {
        return `https://localhost:7148/api/`;
    }
    else {
        return `https://${resolveHost()}/api/`;
    }
}

export function courseProgressHubUrl() {
    if (window.location.href.includes('localhost')) {
        return `https://localhost:7148/courseprogress`;
    }
    else {
        return `https://${resolveHost()}/courseprogress`
    }
}